import { useCallback, useEffect } from 'react';
const useOnClickOutside = (ref, callback) => {
    const handler = useCallback((evt) => {
        if (ref?.current && !ref.current.contains(evt.target)) {
            callback();
        }
    }, [ref, callback]);
    useEffect(() => {
        document.addEventListener('click', handler);
        document.addEventListener('touchstart', handler);
        return () => {
            document.removeEventListener('click', handler);
            document.removeEventListener('touchstart', handler);
        };
    }, [handler]);
};
export default useOnClickOutside;
//# sourceMappingURL=useOnClickOutside.js.map